/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument
 */
export interface HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument
     */
    external_ehr_document_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument
     */
    relation_type?: HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentRelationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument
     */
    relation_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument
     */
    created_at?: string;
}


/**
 * @export
 */
export const HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentRelationTypeEnum = {
    Document: 'screener_document',
    AdditionalDocument: 'screener_additional_document',
    GeneratedDocument: 'screener_generated_document'
} as const;
export type HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentRelationTypeEnum = typeof HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentRelationTypeEnum[keyof typeof HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentRelationTypeEnum];


/**
 * Check if a given object implements the HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument interface.
 */
export function instanceOfHchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument(value: object): value is HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument {
    return true;
}

export function HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSON(json: any): HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument {
    return HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSONTyped(json, false);
}

export function HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'external_ehr_document_id': json['external_ehr_document_id'] == null ? undefined : json['external_ehr_document_id'],
        'relation_type': json['relation_type'] == null ? undefined : json['relation_type'],
        'relation_id': json['relation_id'] == null ? undefined : json['relation_id'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentToJSON(json: any): HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument {
    return HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentToJSONTyped(json, false);
}

export function HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentToJSONTyped(value?: HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'type': value['type'],
        'external_ehr_document_id': value['external_ehr_document_id'],
        'relation_type': value['relation_type'],
        'relation_id': value['relation_id'],
        'created_at': value['created_at'],
    };
}

